<template>
  <div
    class="input-box"
    :class="{
      'isIp': value && data.fieldtype === 'ip' && !isIpError,
      'isrepeatsave': isrepeatsave
    }"
  >
    <i
      v-if="value && data.fieldtype === 'ip' && !isIpError"
      class="iconfont iconmap address-map"
      @click="mapVisible = true"
    />
    <MapModal
      v-if="mapVisible && value && data.fieldtype === 'ip' && !isIpError"
      :visible.sync="mapVisible"
      :ip="value"
      :fieldkey="data.fieldkey"
      :fieldtype="data.fieldtype"
    />
    <input
      v-if="data"
      v-model="value"
      :placeholder="placeholder"
      class="input"
      @input="handleChange"
      @blur="onBlur"
    >
    <cube-validator
      ref="formItem"
      v-model="data.valid"
      :model="value"
      :rules="data.rules"
      :messages="data.messages"
      :immediate="false"
    />
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
import { checkRepeat } from '@/services/inqueryServices'
import MapModal from '@/components/mobile/map/MapModal2'

export default {
  components: {
    MapModal
  },
  props: {
    data: {
      type: Object,
      default: () => ({})
    },
    placeholder: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      value: this.data.fieldvalue || '',
      // valid: this.data.valid || undefined,
      isIpError: false,
      mapVisible: false,
      isrepeatsave: 0
    }
  },
  computed: {
    inquiryId () {
      return this.$route.params.inquiryId
    },
    checkrepeatfieldkey () {
      return this.$route.query.checkrepeatfieldkey
    },
    checkrepeatfieldvalue () {
      return this.$route.query.checkrepeatfieldvalue
    }
  },
  destroyed () {
    this.UPDATE_REPEAT_SAVE_ITEMS({})
  },
  created () {
    const { fieldtype } = this.data || {}
    this.value = this.data.fieldvalue || ''
    this.fillCheckRepeatValue()

    if (fieldtype === 'number') {
      this.data.rules.custom = this.checkNum
    }
    /* else if (fieldtype === 'ip') {
      this.data.rules.custom = this.checkIp
    } */
    this.data.rules.captchaCheck = this.validateRepeat
    this.data.messages.captchaCheck = this.$t('message["134"]')
  },
  methods: {
    ...mapMutations('inquery/detailData', [
      'UPDATE_REPEAT_SAVE_ITEMS'
    ]),
    validate (cb) {
      this.$refs.formItem.validate(cb)
    },
    handleChange (e) {
      let val = e.target.value
      const { fieldtype } = this.data || {}
      if (fieldtype === 'number') {
        val = val.replace(/[\u4E00-\u9FA5]|[\uFE30-\uFFA0]|[a-z]|e/gi, '')
      }
      // this.value = val.trim()
      this.value = val
      this.data.fieldvalue = this.value

      this.$emit('change', this.value)
    },
    fillCheckRepeatValue () {
      const { fieldkey, fieldtype } = this.data
      if (this.checkrepeatfieldkey && this.checkrepeatfieldvalue) {
        if (fieldkey === this.checkrepeatfieldkey) {
          if (fieldtype === 'phone' || fieldtype === 'email') {
            this.value = this.checkrepeatfieldvalue && this.checkrepeatfieldvalue.split(/[,，\s]+/)
          } else {
            this.value = this.checkrepeatfieldvalue
          }
          this.$emit('change', this.value)
        }
      }
    },
    onBlur () {
      this.$refs.formItem.validate((res) => {
        // console.log(res)
      })
    },
    checkNum () {
      let value = this.value
      const { fieldconfig = {}, fieldtype } = this.data
      const { isallowdecimals, isallowminus } = fieldconfig
      if (fieldtype !== 'number' || value === '') {
        return true
      }

      if (!/^(?:0|-?(?:0\.\d*[1-9]|[1-9]\d*(?:\.\d*[0-9])?))$/.test(value)) { // 是数字，包含正负和小数
        this.data.messages.custom = this.$t('message["805"]')
        return false
      }
      if (!isallowminus) { // 禁止负数
        if (!/^(?:0|[1-9]\d*)(?:\.\d*[0-9])?$/.test(value)) {
          this.data.messages.custom = this.$t('message["836"]')
          return false
        }
      }
      if (!isallowdecimals) { // 禁止小数点
        if (!/^(?:0|-?[1-9]\d*)$/.test(value)) {
          this.data.messages.custom = this.$t('message["832"]')
          return false
        }
      }
      return true
    },
    validateRepeat (val) {
      let { fieldkey = '', fieldvalue, fieldrepeat } = this.data || {}
      if (this.$toType(fieldvalue) === 'array') {
        fieldvalue = fieldvalue.filter(item => item !== '')
      } else {
        fieldvalue = fieldvalue.trim()
      }

      return (resolve) => {
        if (!fieldrepeat || !fieldvalue || !fieldvalue.length) {
          return resolve(true)
        }

        checkRepeat().params({
          inquiryid: this.inquiryId,
          fieldkey,
          fieldvalue
        })
          .fetch()
          .then(res => {
            const { payload = {} } = res.data
            const { isrepeat = 0, isrepeatsave = 0 } = payload
            this.isrepeatsave = isrepeat && isrepeatsave

            // 存放查重验证，重复可保存字段
            this.UPDATE_REPEAT_SAVE_ITEMS(Object.assign({}, this.repeatSaveItems, {
              [fieldkey]: this.isrepeatsave
            }))

            resolve(isrepeat === 0)
          })
      }
    }
    /* checkIp () {
      let value = this.value
      const { fieldtype } = this.data
      if (fieldtype !== 'ip' || value === '') {
        return true
      }

      if (!/^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/.test(value)) {
        this.data.messages.custom = 'IP不是有效的IP格式'
        this.isIpError = true
        return false
      }
      this.isIpError = false
      return true
    } */
  }
}
</script>

<style lang="scss" scoped>
.isIp {
  position: relative;
  padding-left: 20px;
}
.input-box ::v-deep {
  width: 100%;
  .input {
    width: 100%;
    outline: none;
    color: #333;
  }
  input::-webkit-input-placeholder,
  .cube-input-field::-webkit-input-placeholder {
    color: #d6d6d6;
  }
  .address-map {
    position: absolute;
    top: 0;
    left: -10px;
    color: #888;
    padding: 0 10px;
    color: #d6d6d6;
  }
}
.isrepeatsave ::v-deep {
  .cube-validator-msg-def {
    color: #f6a953;
  }
}
</style>
